module.exports = __webpack_public_path__ + "images/bannerFR-06846281e79fd75f5d2791e0d6736350.png";